import React from "react";
import Cookies from "universal-cookie";
import { ROLE } from "../../config";
import AdminPettyCashList from "../../components/petty_cash/AdminPettyCashList";
import EmployeePettyCashLedger from "../../components/petty_cash/EmployeePettyCashLedger";

const cookies = new Cookies();

function PettyCashList() {
  const role = cookies.get(ROLE);

  if (role === "COMPANY_ADMIN") {
    return <AdminPettyCashList />;
  }

  return <EmployeePettyCashLedger />;
}

export default PettyCashList;
